import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import type { FileFindInterface } from '@zaoblako/shared/modules/storage/dtos/file-find.dto';
import { ErrorService } from '@zaoblako/web/core/services/error.service';
import { forkJoin, Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FileService {
  public constructor(private readonly http: HttpClient, private readonly errorService: ErrorService) {}

  public upload(files: FileList, queryParams?: { scaleTo: number }): Observable<FileFindInterface[]> {
    const filesObservables: Observable<FileFindInterface>[] = [];

    if (files) {
      for (let i = 0; i < files.length; i++) {
        const formData = new FormData();
        formData.append('file', files[i], files[i].name);
        filesObservables.push(this.http.post<FileFindInterface>('/file', formData, { params: queryParams }));
      }
    }

    return filesObservables.length
      ? forkJoin(filesObservables).pipe(
          catchError((error) => {
            this.errorService.addDefaultError(error);
            return throwError(error);
          })
        )
      : of([]);
  }

  public getPastedImage(event: ClipboardEvent): Observable<FileFindInterface | null> {
    const images = this.getImageFromEvent(event);

    if (images) {
      event.preventDefault();
      return this.upload(images).pipe(map((createdImages) => createdImages[0]));
    }

    return of(null);
  }

  private getImageFromEvent(event: ClipboardEvent): FileList | null {
    return event.clipboardData &&
      event.clipboardData.files &&
      event.clipboardData.files.length === 1 &&
      event.clipboardData.files[0].type.search(/^image\//i) === 0
      ? event.clipboardData.files
      : null;
  }
}
